import styled from 'styled-components';

import SocialIcon from './SocialIcon';

const SocialButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.5rem;
  height: 3.5rem;
  background: #00cfff;
  border-radius: 100%;
  cursor: pointer;

  ${SocialIcon} {
    font-size: 2rem;
    margin-bottom: -0.5rem;
  }
`;

export default SocialButton;
